import { AddCompanyForm } from "./AddCompanyForm";
import { supabase } from "@/integrations/supabase/client";

export default function AddCompanyPopup() {
  // Handler for company creation
  const handleSubmit = async (companyData: any) => {
    // Actually insert the company into the database
    const { data, error } = await supabase
      .from("companies")
      .insert([companyData])
      .select()
      .single();

    if (error) {
      alert("Error creating company: " + error.message);
      return false;
    }

    if (window.opener && data) {
      window.opener.postMessage({ type: "company-created", company: data }, "*");
    }
    window.close();
    return true;
  };

  return (
    <div style={{ minWidth: 400, minHeight: 400, padding: 24 }}>
      <AddCompanyForm isOpen={true} onClose={() => window.close()} onSubmit={handleSubmit} />
    </div>
  );
} 